import { defineStore } from "pinia";
import { ref, computed } from "vue";

export interface Profile {
  id: number;
  name: string;
  [key: string]: any;
}

export interface Permissions {
  activo: number;
  nombrePermiso: string;
  nombreRol: string;
  permisoId: number;
  rolId: number;
}

export const useListPermissionStore = defineStore(
  "listPermission",
  () => {
    const listProfiles = ref<Profile[]>([]);
    const listPermissionsAdmin = ref<Permissions[]>([]);
    const listPermissionsUsers = ref<Permissions[]>([]);
    const roleIdSeleccionado = ref<number | null>(null);

    const setListProfiles = (profiles: Profile[]) => {
      listProfiles.value = profiles;
      globalThis.dispatchEvent(new CustomEvent("portalcash:update-profiles", { detail: profiles }));
    };

    const setRoleIdSeleccionado = (roleId: number) => {
      roleIdSeleccionado.value = roleId;
      globalThis.dispatchEvent(new CustomEvent("portalcash:update-role", { detail: roleId }));
    };

    const setListPermissionsAdmin = (permissions: Permissions[]) => {
      listPermissionsAdmin.value = permissions;
      globalThis.dispatchEvent(new CustomEvent("portalcash:update-permissions-admin", { detail: permissions }));
    };

    const setListPermissionsUsers = (permissions: Permissions[]) => {
      listPermissionsUsers.value = permissions;
      globalThis.dispatchEvent(new CustomEvent("portalcash:update-permissions-users", { detail: permissions }));
    };

    if (typeof globalThis !== "undefined") {
      globalThis.addEventListener("portalcash:update-profiles", ((e: CustomEvent) => {
        listProfiles.value = e.detail;
      }) as EventListener);
      globalThis.addEventListener("portalcash:update-role", ((e: CustomEvent) => {
        roleIdSeleccionado.value = e.detail;
      }) as EventListener);
      globalThis.addEventListener("portalcash:update-permissions-admin", ((e: CustomEvent) => {
        listPermissionsAdmin.value = e.detail;
      }) as EventListener);
      globalThis.addEventListener("portalcash:update-permissions-users", ((e: CustomEvent) => {
        listPermissionsUsers.value = e.detail;
      }) as EventListener);
    }

    return {
      listProfiles,
      roleIdSeleccionado,
      listPermissionsAdmin,
      listPermissionsUsers,
      setListProfiles,
      setRoleIdSeleccionado,
      setListPermissionsAdmin,
      setListPermissionsUsers,
    };
  },
  {
    persist: [
      {
        key: "listPermission-admin",
        storage: localStorage,
        pick: ["listPermissionsAdmin", "listProfiles"],
      },
      {
        key: "listPermission-session",
        storage: sessionStorage,
        pick: ["listPermissionsUsers", "roleIdSeleccionado"],
      },
    ],
  },
);
